// extracted by mini-css-extract-plugin
export default {"page":"Wholesale_page__krUM3","header":"Wholesale_header__1anRa"};